export enum PropertyType {
  None = 0,
  Portfolio = 1,
  Property = 2,
  Building = 3,
  Unit = 4,
}

export interface IPortfolioUPPDState {
  portfolioId: number;
  propertyIds: number[];
  allPropertiesSelected: boolean;
}

export interface ICollectionUPPDState {
  collectionIds: number[];
  collectionPropertyIds: number[];
}
